import manage from './manage';
import list from './list';
import answers from './answers';

export default [...list, ...manage, ...answers];
